import React from 'react';
//import P from 'prop-types';
import { GlobalContext } from '../../contexts/HomeContext';
//import { GetDadosPix } from '../../utils/api/api';
import QRCode from 'react-qr-code';
import { toast } from 'react-toastify';
import { IPedidoSelecionadoType } from '../../Types/index';

interface Props {
  pedidoSelecionado: IPedidoSelecionadoType;
  shadow: boolean;
  title: boolean;
  padTop: number;
  padBottom: number;
}

/*
  Observaçãoes: <br />
  Ao finalizar o pedido com a opção PIX, já chama o método que estou usando aqui para gerar o qrcode e o pix_copia_cola,
  e grava na tabela do pedido ou em alguma outra para organizar melhor, e amarra pelo numero do pedido, desta forma aqui
  quando for exibir e ainda não tiver sido pago, exibe.
  <br />E caso o código não tiver sido gerado corretamente na finalização, por qualquer erro que seja, então o pedido
  não podera ser finalizado. <br />E parece que o CPF é um campo obrigatório para o PIX, mas para o link de pedidos não,
  então teria que tratar este campo, pedindo pro usuário preencher o CPF no seu cadastro, caso queira pagar com PIX.
*/

const Timeline: React.FC<Props> = ({
  pedidoSelecionado,
  shadow = false,
  title = true,
  padTop = 25,
  padBottom = 25,
}) => {
  const { dadosApp } = React.useContext(GlobalContext);
  const dataPedido = new Date(pedidoSelecionado.datahora_pedido); // verificar a data de importação
  const dataConfirmacao = new Date(pedidoSelecionado.importado_data); // verificar a data de importação
  const dataPrevisao = new Date(pedidoSelecionado.previsao) as Date;
  //console.log('pedidoSelecionado', pedidoSelecionado);
  const pix = pedidoSelecionado?.pagamento ? pedidoSelecionado?.pagamento[0]?.toUpperCase() === 'PIX' : false;
  const pago = pix
    ? pedidoSelecionado?.dadosPix && pedidoSelecionado?.dadosPix[0]?.pago === 1
    : pedidoSelecionado?.online // eslint-disable-next-line prettier/prettier
      ? pedidoSelecionado?.online[0] // eslint-disable-next-line prettier/prettier
      : false;
  const dataPagamento =
    pix && pedidoSelecionado?.dadosPix ? new Date(pedidoSelecionado.dadosPix[0]?.datahora) : new Date();

  return (
    <div
      className={`widget-timeline-icon`}
      style={{
        padding: 25,
        paddingTop: padTop,
        paddingBottom: padBottom,
        borderRadius: 20,
        boxShadow: shadow ? '0 12px 23px 0 rgb(62 73 84 / 4%)' : 'none',
      }}
    >
      {title && <h4 className="card-title">Histórico</h4>}
      <ul className="timeline">
        {pedidoSelecionado.confirmado && (
          <>
            {dadosApp.TipoApp === 'DELIVERY' && (
              <li>
                <div className="icon bg-primary" />
                <div className="timeline-panel text-muted">
                  <h4 className="mb-2">Previsão de Entrega</h4>
                  <p className="fs-15 pb-3 ">
                    {dataPrevisao?.toLocaleDateString('pt-BR', {
                      year: 'numeric',
                      month: 'long',
                      weekday: 'long',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric',
                    })}
                  </p>
                </div>
              </li>
            )}
            <li>
              <div className="icon bg-primary" />
              <div className="timeline-panel text-muted">
                <h4 className="mb-2">Pedido Confirmado</h4>
                <p className="fs-15 pb-3 ">
                  Seu pedido esta sendo preparado <br />
                  {dataConfirmacao.toLocaleDateString('pt-BR', {
                    year: 'numeric',
                    month: 'long',
                    weekday: 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                  })}
                </p>
              </div>
            </li>
          </>
        )}

        {/* {!pedidoSelecionado.confirmado && !pix && ( */}
        {!pedidoSelecionado.confirmado && pago && (
          <li>
            <div className="icon bg-warning" />
            <div className="timeline-panel text-muted">
              <h4 className="mb-2">Pendente Confirmação</h4>
              <p className="fs-15 pb-3 ">O Pedido foi enviado mas esta pendente de confirmação pelo estabelecimento</p>
            </div>
          </li>
        )}

        {!pedidoSelecionado.confirmado &&
          pedidoSelecionado.online &&
          pedidoSelecionado.pagamento &&
          !pedidoSelecionado.online[0] &&
          !pix && (
            <li>
              <div className="icon bg-warning" />
              <div className="timeline-panel text-muted">
                <h4 className="mb-2">Pendente Confirmação</h4>
                <p className="fs-15 pb-3 ">
                  O Pedido foi enviado mas esta pendente de confirmação pelo estabelecimento
                </p>
              </div>
            </li>
          )}

        {/* {!pago && <>Somente após o pagamento ser realizado, o seu pedido será</>} */}

        <li>
          <div className={`icon ${pix && !pago ? 'bg-warning' : 'bg-primary'}`} />
          <div className="timeline-panel text-muted">
            <h4 className="mb-2">Pagamento</h4>
            <p className="fs-15 pb-3">
              {/* {pedidoSelecionado.online && pedidoSelecionado.online[0] && 'Pago Online'} */}
              {pago && pix && (
                <>
                  Pago via PIX <br />
                </>
              )}
              {pago && !pix && (
                <>
                  Pago Online <br />
                </>
              )}

              {pago &&
                pix &&
                dataPagamento?.toLocaleDateString('pt-BR', {
                  year: 'numeric',
                  month: 'long',
                  weekday: 'long',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  second: 'numeric',
                })}
              {pago &&
                !pix &&
                dataPedido.toLocaleDateString('pt-BR', {
                  year: 'numeric',
                  month: 'long',
                  weekday: 'long',
                  day: 'numeric',
                  hour: 'numeric',
                  minute: 'numeric',
                  second: 'numeric',
                })}
              {pedidoSelecionado.online && pedidoSelecionado.pagamento && !pedidoSelecionado.online[0] && !pix && (
                <>Pagar na Entrega: {pedidoSelecionado.pagamento[0]?.toUpperCase()}</>
              )}

              {/* {pix && pedidoSelecionado.pagamento && <>Pendente: {pedidoSelecionado.pagamento[0]?.toUpperCase()}</>} */}
              {pix && !pago && pedidoSelecionado.pagamento && (
                <>Pendente: {pedidoSelecionado.pagamento[0]?.toUpperCase()}</>
              )}

              {!pago && pedidoSelecionado.dadosPix && pedidoSelecionado.dadosPix?.length > 0 && (
                <div style={{ textAlign: 'center' }}>
                  <div style={{ textAlign: 'center', padding: '30px 0 20px 0' }}>
                    <QRCode value={pedidoSelecionado.dadosPix[0]?.pix_qr_code} size={128} />
                  </div>
                  Copiar Código PIX
                  <div
                    className="form-group row"
                    style={{ margin: '0px 0 35px', cursor: 'pointer' }}
                    title="Copiar Código PIX"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        pedidoSelecionado.dadosPix ? pedidoSelecionado.dadosPix[0]?.pix_copia_cola : '',
                      );
                      toast.success('Código PIX Copiado', { autoClose: 2500 });
                    }}
                  >
                    <div className="col-sm-12" data-toggle="tooltip">
                      <div
                        style={{
                          fontSize: 16,
                          fontWeight: 600,
                          lineHeight: 2.5,
                          background: 'rgb(251, 251, 251)',
                          marginTop: 10,
                          overflow: 'hidden',
                          paddingRight: 37,
                        }}
                        className="form-control text-center text-muted cardShadow"
                      >
                        <div
                          style={{
                            fontSize: 16,
                            fontWeight: 600,
                            lineHeight: 2.5,
                            background: 'rgb(251, 251, 251)',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                          className="text-center text-muted"
                        >
                          {pedidoSelecionado.dadosPix[0]?.pix_copia_cola}
                        </div>
                        <span
                          className="btn-icon-left text-success cursor-pointer"
                          style={{
                            position: 'absolute',
                            right: 10,
                            top: 40,
                            background: '#fbfbfb',
                            borderRadius: '10rem',
                            display: 'inline-block',
                            float: 'left',
                            margin: '-1.5rem .75rem -.5rem -1.188rem',
                            padding: '0.5rem .5rem',
                            color: '#2bc155',
                            height: 40,
                            width: 40,
                          }}
                        >
                          <i className="material-icons" style={{ color: '#2bc155' }}>
                            content_copy
                          </i>{' '}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </p>
          </div>
        </li>

        <li>
          <div className="icon bg-primary" />
          <div className="timeline-panel text-muted">
            <h4 className="mb-2">Pedido Realizado</h4>
            <p className="fs-15 mb-0 ">
              {dataPedido.toLocaleDateString('pt-BR', {
                year: 'numeric',
                month: 'long',
                weekday: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
              })}
            </p>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default Timeline;
// Timeline.propTypes = {
//   pedidoSelecionado: P.object,
//   shadow: P.bool,
//   title: P.bool,
//   padTop: P.number,
//   padBottom: P.number,
// };
